import { BusinessAccountDetailsRaw } from '@shared/models';

export const businessAcccountMock: BusinessAccountDetailsRaw = {
  createdBy: {
    id: '99999999-9999-9999-9999-999999999999',
    type: 'internal',
  },
  createdAt: '2024-01-01T00:00:00.000Z',
  updatedBy: {
    id: '99999999-9999-9999-9999-999999999999',
    type: 'internal',
  },
  updatedAt: '2024-04-25T14:06:52.112748Z',
  id: '523f836d-eb3d-4031-bca7-02e8d04868ce',
  phoneNumbers: [
    {
      number: '+12345612345',
      primary: true,
      verified: false,
    },
  ],
  emails: [
    {
      value: 'email@example.com',
      primary: true,
      verified: false,
    },
  ],
  primaryEmail: 'email@example.com',
  primaryPhoneNumber: '+12345612345',
  parentId: 'e1cfd12e-8af4-4dc4-83c7-ce19d5a16d4a',
  name: 'rbcchild-74a54a0c-0c28-4f00-b796-056d9116b850',
  legalName: 'BA legal name',
  operatingName: 'BA op name',
  description: 'BA description',
  website: 'https://example.com',
  branding: {
    primaryColor: '#1a73e8',
    supportEmail: 'support@example.com',
    linxBaseUrl: 'https://app.example.com/#',
  },
  state: 'ACTIVE',
  shortId: 'ABCDEFGH0A',
  organizationType: 'BUSINESS',
  legalEntityType: 'LLC',
  industryCode: '002007',
  addresses: [
    {
      id: '177e3c4a-fa8d-4c92-af9f-32b3239c0dc4',
      type: 'PHYSICAL',
      streetLine1: '111 Peter Str, Toronto',
      zipCode: '123456',
      countryCode: 'CA',
      stateCode: 'ON',
      cityName: 'Ottawa',
      primary: false,
    },
  ],
  currency: 'USD',
};
